'use client';

import type { FC } from 'react';
import { Button } from '../../ui';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './RushMid.translations';

/** Shown in place of the start/search button when a newer frontend build is live: a stale
 *  bundle must NOT start a match (it may mis-read new snapshot events), so the only action
 *  offered is a reload. Lives only in the lobby / party screens — never a global banner. */
export const LobbyUpdateNotice: FC = () => {
  const { t } = useLocalTranslation(translations);
  return (
    <div className="flex flex-col items-stretch gap-2">
      <div className="rounded-xl border border-gold/30 bg-gold/10 px-4 py-2 text-center text-sm font-semibold text-gold">
        {t('updateBanner')}
      </div>
      <Button variant="primary" size="l" stretched data-sound="cta" onClick={() => window.location.reload()}>
        {t('updateNow')}
      </Button>
    </div>
  );
};
